import { Box, Typography } from "@mui/material";
import { Stack, styled } from "@mui/system";
import img from "../../assets/Images/bh.png";

export const CloseButtonWrapper = styled(Box)({
  display: "flex",
  justifyContent: "flex-end",
  padding: "0 10px",
});

export const CloseButton = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "50px",
  height: "30px",
  width: "30px",
  background: "white",
  cursor: "pointer",
});

export const ModalWrapper = styled(Box)({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  borderRadius: "20px",
  zIndex: 1,
  backgroundColor: "white",
  backgroundImage: `url(${img})`,
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  boxShadow: "24px",
  width: "600px",
  maxWidth: "750px",
  paddingTop: "10px",
  paddingBottom: "50px",
});

export const Header = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  padding: "0 32px 16px",
});

export const Divider = styled(Box)({
  height: "1px",
  background: "#EAF1FA",
});

export const Content = styled(Box)({
  display: "flex",
  flexDirection: "column",
  //   gap: "8px",
  padding: "24px 24px",
  //   paddingBottom: 0,
});

export const InstructionWrapper = styled(Box)({
  padding: "0 16px 16px",
});

export const Title = styled(Typography)({
  fontSize: "26px",
  fontWeight: 600,
  color: "#01060B",
  marginBottom: "10px",
});

export const Description = styled(Typography)({
  display: "flex",
  // alignItems: "center",
  gap: "10px",
  fontSize: "16px",
  fontWeight: 400,
  color: "#2C3034",
});

export const ButtonWrapper = styled(Box)<{isTax?:boolean, isSearch?:boolean}>(({isTax, isSearch}) => ({
  display: isTax ? "flex" : "block",
  gap: isTax ? "10px" : "0",
  justifyContent: !isSearch ? "right" : "left",
  padding: isSearch ? "0" : "0 36px",
}));

export const StyledErrorMessage = styled(Box)({
  color: "red",
  fontWeight: 400,
  textAlign: "left",
  padding: "0px 0px 10px 0px",
  wordWrap: "break-word",
  overflowWrap: "break-word",
  // width: "60%", // Adjust width as needed
});
export const StyledTypographyLLc = styled(Typography)(({ theme }) => ({
  color: "#060110",
  fontSize: "18px",
  fontWeight: 600,
  // paddingBottom: theme.spacing(2), // Uncomment if needed
}));
